import { Link } from 'react-router-dom'

/**
 * Reciprocal navigation for the Details page's "Site Info / Analytics /
 * Alarms / Alarm subscriptions / Maintenance" quick links - without this,
 * following one of those from the Details page left no way back to its
 * graphs. Shown whenever a controller is selected, on every page the
 * Details page links out to.
 */
export function BackToDetailsLink({ controllerId }: { controllerId: string }) {
  if (!controllerId) return null
  return (
    <Link
      to={`/site-details?controller=${controllerId}`}
      className="inline-flex items-center gap-1 text-sm text-brand hover:underline"
    >
      ← Back to site details
    </Link>
  )
}
